import mixitup from 'mixitup';

let mixer;

const updateFilter = (filterValue) => {
    var containerEl = document.querySelector('.mixContainer');
    if (containerEl) {
        containerEl.setAttribute('data-currentfilter', filterValue.replace('.', ''));
    }
};

const init = () => {
    var containerEl = document.querySelector('.mixContainer');
    if (containerEl && !mixer) {
        mixer = mixitup(containerEl, {
            selectors: {
                target: '.mix',
            },
            animation: {
                duration: 300,
                effects: 'fade scale'
            },
        })

        updateFilter(mixer.getState().activeFilter.selector);

        containerEl.addEventListener('mixEnd', () => {
            updateFilter(mixer.getState().activeFilter.selector);
        });
    }
};

export default init;